import React, { useEffect } from 'react'
import { Button, Icon, Table, Loader } from 'semantic-ui-react'
import moment from 'moment'
import { headers } from './data'
import useHistory from './useHistory'


const DisHistoryDetails = ({ onClose }) => {
    const { getHistory, history,  loading, handleSeeDocument } = useHistory()

    useEffect(() => {
        getHistory()
    }, [])


    return (
        <>
            <div className='force-scrollbar historyTable'>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            {headers.map((header) => (
                                <Table.HeaderCell key={header.id}>
                                    {header.label}
                                </Table.HeaderCell>
                            ))}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {loading ? (
                            <Table.Row>
                                <Table.Cell colSpan={headers?.length||9} textAlign="center">
                                    <Loader indeterminate active inline size='small' />Loading history...
                                </Table.Cell>
                            </Table.Row>
                        ) : history?.length ? (
                            history.map((item, index) => (
                                <Table.Row  key={'disHistoryRow' + index} >
                                    <Table.Cell>{item?.documentLabel||"-"}</Table.Cell>
                                    <Table.Cell>{item?.status||"-"}</Table.Cell>
                                    <Table.Cell>{item?.responseStatus || "-"}</Table.Cell>
                                    <Table.Cell>
                                        {item.requestDocTime
                                            ? moment(item.requestDocTime, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do YYYY, h:mm a')
                                            : '-'}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {item?.responseDocTime
                                            ? moment(item.responseDocTime, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do YYYY, h:mm a')
                                            : "-"}
                                    </Table.Cell>
                                    <Table.Cell>{item.comment||"-"}</Table.Cell>

                                    <Table.Cell>{item.drDocumentReviewComment||"-"}</Table.Cell>
                                    <Table.Cell>{item.drDocumentRejectReason||"-"}</Table.Cell>
                                    <Table.Cell>
                                        {item?.completeFileName && (
                                            <Button
                                                basic
                                                size="Small"
                                                color="blue"
                                                onClick={() => {
                                                    handleSeeDocument(item?.completeFileName)
                                                }}
                                            >
                                                See Document
                                            </Button>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))
                        ) : (
                            <Table.Row>
                                <Table.Cell colSpan={history?.length||9} textAlign="center">
                                    No history records found.
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>

                </Table>
            </div>
        </>
    )
}

export default React.memo(DisHistoryDetails)
